import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=2f282508&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=2f282508&scoped=true&lang=less&"
import style1 from "./orderList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderList.vue?vue&type=style&index=2&id=2f282508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f282508",
  null
  
)

export default component.exports